import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=4d74474a&"
import script from "./UserView.vue?vue&type=script&lang=js&"
export * from "./UserView.vue?vue&type=script&lang=js&"
import style0 from "./UserView.vue?vue&type=style&index=0&id=4d74474a&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d74474a')) {
      api.createRecord('4d74474a', component.options)
    } else {
      api.reload('4d74474a', component.options)
    }
    module.hot.accept("./UserView.vue?vue&type=template&id=4d74474a&", function () {
      api.rerender('4d74474a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/UserView.vue
// module id = 508
// module chunks = 8